import PropTypes from 'prop-types';
import { Box, Typography, Switch, Tooltip, ListItemIcon } from '@material-ui/core';
import { Icon } from '@iconify/react';
import moonFill from '@iconify/icons-eva/moon-fill';
import sunFill from '@iconify/icons-eva/sun-fill';
import useSettings from '../hooks/useSettings';

DarkModeToggle.propTypes = {
  isCollapsed: PropTypes.bool,
};

export default function DarkModeToggle({ isCollapsed }) {
  const { themeMode, onChangeMode } = useSettings();

  const handleToggle = (e) => {
    onChangeMode({ target: { value: e.target.checked ? 'dark' : 'light' } });
  };

  if (isCollapsed) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        height: 48
      }}>
        <Tooltip title={themeMode === 'dark' ? "Switch to Light Mode" : "Switch to Dark Mode"} placement="right">
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
            <Icon 
              icon={themeMode === 'dark' ? moonFill : sunFill} 
              width={20} 
              height={20} 
              color={themeMode === 'dark' ? '#90caf9' : '#fbc02d'} 
            />
            <Switch
              size="small"
              checked={themeMode === 'dark'}
              onChange={handleToggle}
            />
          </Box>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between', 
      height: 48,
      pl: 5,
      pr: 2.5
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <ListItemIcon sx={{ width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Icon 
            icon={themeMode === 'dark' ? moonFill : sunFill} 
            width={20} 
            height={20} 
            color={themeMode === 'dark' ? '#90caf9' : '#fbc02d'} 
          />
        </ListItemIcon>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          Dark Mode
        </Typography>
      </Box>
      <Switch
        size="small"
        checked={themeMode === 'dark'}
        onChange={handleToggle}
      />
    </Box>
  );
}